import React from "react";
import { SVG, IconProps } from "../SVG";
export const SpotKey = ({
    spotColor = "#C9DBFE",
    color = "#13126C",
    strokeWidth = "2.2",
    ...props
}: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 40 40" {...props}>
        <g clipPath="url(#Spot=on,_Size=40_svg__a)">
            <path
                fill={spotColor}
                d="M4.857 17.78c1.738-5.087 7.916-9.787 13.373-11.594 5.482-1.818 11.979-.362 16.283 3.888 4.304 4.25 6.402 10.611 5.107 15.97-1.26 5.374-5.757 8.608-9.715 10.583-3.983 1.985-7.428 1.992-11.538.997-4.123-.96-8.301-2.541-10.448-6.26-2.147-3.72-4.824-8.487-3.062-13.584Z"
            />
            <path
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={strokeWidth}
                d="m25.834 12.5 5.833-5.834m3.334-3.333-3.334 3.333 3.334-3.333ZM18.984 19.35a9.165 9.165 0 0 1-2.945 15A9.167 9.167 0 0 1 6.02 32.313a9.167 9.167 0 0 1 12.962-12.962l.002-.001Zm0 0 6.85-6.85-6.85 6.85Zm6.85-6.85 5 5 5.833-5.834-5-5-5.833 5.834Z"
            />
        </g>
        <defs>
            <clipPath id="Spot=on,_Size=40_svg__a">
                <path fill="#fff" d="M0 0h40v40H0z" />
            </clipPath>
        </defs>
    </SVG>
);
SpotKey.displayName = "SpotKey";
